import { apiConstants } from "../utils/apiConstants";
import * as yup from "yup";
import { errorMessage } from "../utils/constants";
import moment from "moment";
import { getNumberWithIsd, normalize } from "../utils";
import { countryList, preConfigDeptData } from "./data";
import { DateUtils } from "../utils/dateUtils";

export const signUpFormData = () => {
  return {
    [apiConstants.full_name]: "",
    [apiConstants.email]: "",
    [apiConstants.mobile_number]: "",
    [apiConstants.password]: "",
    [apiConstants.terms_accepted]: false,
  };
};

export const crewSignUpFormData = () => {
  return {
    [apiConstants.first_name]: '',
    [apiConstants.last_name]: '',
    [apiConstants.email]: '',
    [apiConstants.mobile_number]: '',
    [apiConstants.password]: '',
    [apiConstants.terms_accepted]: false,
    [apiConstants.dial_code]: {
      "name": "United Kingdom",
      "flag": "🇬🇧",
      "code": "GB",
      "dial_code": "+44",
      "value": "+44",
      "label": "United Kingdom"
    },
  }
}

export const defaultPreviousRole = () => {
  return {
    [apiConstants.department]: '',
    [apiConstants.position]: '',
    [apiConstants.production]: '',
    [apiConstants.studio]: '',
    [apiConstants.imdb_link]: '',
  }
};

export const crewReferenceFormData = () => {
  return {
    [apiConstants.reference_name]: '',
    [apiConstants.reference_email]: '',
    [apiConstants.reference_mobile_number]: '',
    [apiConstants.dial_code]: '+61',
  }
}

export const basicDetailFormData = (data: any) => {
  const mappedDepartments =
    data?.crew_member_profile?.role?.map(
      (item: any) => {

        const selectedDepartment =
          preConfigDeptData.find(
            (dept: any) =>
              dept.label === item.dep
          );

        const selectedRoles =
          selectedDepartment?.roles?.filter(
            (roleItem: any) =>
              item.role?.includes(
                roleItem.label
              )
          ) || [];

        return {
          department:
            selectedDepartment || null,

          roles: selectedRoles,
        };
      }
    ) || [
      {
        department: null,
        roles: [],
      },
    ];

  return {
    [apiConstants.IMDB_link]: data?.crew_member_profile?.imdb_link || "",
    [apiConstants.biography]: data?.crew_member_profile?.bio || '',
    [apiConstants.working_days]: data?.crew_member_profile?.working_days ? normalize(data?.crew_member_profile?.working_days) : [],
    [apiConstants.profile_image]: data?.profile_image || null,
    departments: mappedDepartments,
  }
}

export const crewLocationFormData = (data: any) => {
  return {
    city: data?.city || "",
    country: data?.country || "",
    lat: data?.coordinates?.coordinates?.[0] || "",
    lng: data?.coordinates?.coordinates?.[1] || '',
    location: data?.address || "",
    post_code: data?.postcode || "",
    radius: ""
  }
}

export const checkEmailFormData = (data: any) => {
  return {
    [apiConstants.email]: data?.email || "",
  };
};
export const signInFormData = (data?: any) => {
  return {
    [apiConstants.email]: data?.email || "",
    [apiConstants.password]: "",
  };
};
export const ownerFormData = (data: any) => {
  const ownerProfile = data?.owner_profile;

  let mobileNumber = "";
  if (data?.mobile_number) {
    const [isdCode, contact]: any = getNumberWithIsd(data?.mobile_number);
    mobileNumber = contact;
  }

  return {
    [apiConstants.company_logo]:
      ownerProfile?.[apiConstants.company_logo] || "",
    [apiConstants.company_name]:
      ownerProfile?.[apiConstants.company_name] || "",
    [apiConstants.contact_person]:
      ownerProfile?.[apiConstants.contact_person] || "",
    [apiConstants.mobile_number]: mobileNumber || "",
    [apiConstants.email]: data?.email || "",
  };
};
export const ownerAddressFormData = (data: any) => {
  return {
    [apiConstants.address]: data?.[apiConstants.address] || "",
    [apiConstants.city]: data?.[apiConstants.city] || "",
    [apiConstants.post_code]: data?.[apiConstants.post_code] || "",
    [apiConstants.coordinates]: data?.[apiConstants.coordinates] || "",
  };
};
export const ownerRateFormData = (data: any) => {
  const ownerProfile = data?.owner_profile;

  return {
    [apiConstants.sixth_day_earning_rates]:
      ownerProfile?.[apiConstants.sixth_day_earning_rates] || "",
    [apiConstants.seventh_day_earning_rates]:
      ownerProfile?.[apiConstants.seventh_day_earning_rates] || "",
  };
};
export const supplierFormData = (data: any) => {
  const supplierProfile = data?.supplier_profile;

  return {
    [apiConstants.company_logo]:
      supplierProfile?.[apiConstants.company_logo] || "",
    [apiConstants.company_name]:
      supplierProfile?.[apiConstants.company_name] || "",
    [apiConstants.bio]: supplierProfile?.[apiConstants.bio] || "",
    [apiConstants.email]: data?.email || "",
  };
};
export const supplierInfoData = (data: any) => {
  const supplierProfile = data?.supplier_profile;

  let mobileNumber = "";
  if (data?.mobile_number) {
    const [isdCode, contact]: any = getNumberWithIsd(data?.mobile_number);
    mobileNumber = contact;
  }

  return {
    [apiConstants.profile_image]: data?.[apiConstants.profile_image] || "",
    [apiConstants.mobile_number]: mobileNumber || "",
    [apiConstants.website]: supplierProfile?.[apiConstants.website] || "",
    [apiConstants.contact_person]: `${data?.first_name || ""} ${data?.last_name || ""
      }`,
  };
};

export const addServicesFormData = () => {
  return {
    [apiConstants.service]: "",
  };
};

export const addProductFormData = () => {
  return {
    [apiConstants.product]: "",
  };
};
export const createJob = (data: any) => {
  return {
    [apiConstants.image]: data?.[apiConstants.image] || "",
    [apiConstants.title]: data?.[apiConstants.title] || "",
    [apiConstants.department]: data?.[apiConstants.department] || "",
    [apiConstants.daily_rate]: data?.[apiConstants.daily_rate] || "",
    [apiConstants.location]: data?.[apiConstants.location] || "",
    [apiConstants.number_of_positions]:
      data?.[apiConstants.number_of_positions] || "",
    [apiConstants.start_date]: moment(data?.[apiConstants.start_date]) || "",
    [apiConstants.end_date]: moment(data?.[apiConstants.end_date]) || "",
    [apiConstants.description]: data?.[apiConstants.description] || "",
  };
};

export const createUser = () => {
  return {
    [apiConstants.email]: "",
    [apiConstants.first_name]: "",
    [apiConstants.last_name]: "",
  };
};
export const sendInvite = () => {
  return {
    [apiConstants.email]: "",
  };
};

export const inviteSupplier = () => {
  return {
    [apiConstants.email]: "",
    [apiConstants.first_name]: "",
  };
};

export const createJobSchema = () => {
  return yup
    .object()
    .shape({
      // [apiConstants.image]: yup.string().required(errorMessage.required_validation('Image')),
      [apiConstants.department]: yup
        .string()
        .required(errorMessage.required_validation("Department")),
      [apiConstants.title]: yup
        .string()
        .required(errorMessage.required_validation("Job title")),
      [apiConstants.daily_rate]: yup
        .string()
        .required(errorMessage.required_validation("Daily rate"))
        .matches(
          new RegExp(/^[+]?([.]\d+|\d+[.]?\d*)$/),
          "Daily rate must be positive"
        ),
      [apiConstants.number_of_positions]: yup
        .string()
        .required(errorMessage.required_validation("Number of positions"))
        .matches(
          new RegExp(/^[+]?([.]\d+|\d+[.]?\d*)$/),
          "Number of positions must be positive"
        ),
      [apiConstants.location]: yup
        .string()
        .required(errorMessage.required_validation("Location")),
      [apiConstants.start_date]: yup
        .string()
        .required(errorMessage.required_validation("Start date")),
      [apiConstants.end_date]: yup
        .string()
        .required(errorMessage.required_validation("End date")),
    })
    .required();
};
export const createEventSchema = () => {
  return yup
    .object()
    .shape({
      // [apiConstants.image]: yup.string().required(errorMessage.required_validation('Image')),
      [apiConstants.event_type]: yup
        .string()
        .required(errorMessage.required_validation("Event type")),
      // [apiConstants.department]: yup.string().required(errorMessage.required_validation('Department')),
      [apiConstants.department]: yup
        .array()
        .min(1, errorMessage.selectFieldRequired("department")),
      [apiConstants.eventStartTime]: yup
        .string()
        .required(errorMessage.required_validation("Start time")),
      [apiConstants.eventEndTime]: yup
        .string()
        .required(errorMessage.required_validation("End time")),
      [apiConstants.event_start_date]: yup
        .string()
        .required(errorMessage.required_validation("Date")),
      [apiConstants.eventName]: yup
        .string()
        .required(errorMessage.required_validation("Event Name")),
      [apiConstants.eventSubCategory]: yup
        .string()
        .required(errorMessage.required_validation("Event Sub Category")),
      //[apiConstants.meeting_link]: yup.string().required(errorMessage.required_validation('Meeting Link')),
      [apiConstants.description]: yup
        .string()
        .required(errorMessage.required_validation("Event Description")),
      [apiConstants.evt_timezone]: yup
        .string()
        .required(errorMessage.required_validation("Event Timezone")),
      //[apiConstants.event_address]: yup.string().required(errorMessage.required_validation('Location'))
    })
    .required();
};

export const locationSchema = () => {
  return yup
    .object()
    .shape({
      [apiConstants.event_address]: yup
        .string()
        .required(errorMessage.required_validation("Location")),
    })
    .required();
};

export const changePassFormData = () => {
  return {
    [apiConstants.old_password]: "",
    [apiConstants.password]: "",
  };
};

export const createLocationFormData = (data?: any) => {
  let mobileNumber = "", ISDCode = '';
  if (data?.contact_phone_number) {
    const [isdCode, contact]: any = getNumberWithIsd(data?.contact_phone_number);
    mobileNumber = contact;
    ISDCode = isdCode
  }
  const country: any = countryList?.find((item) => item?.dial_code == ISDCode) || {};
  return {
    [apiConstants.name]: data?.[apiConstants.name] || "",
    [apiConstants.coordinates]: data?.[apiConstants.coordinates] || null,
    [apiConstants.address]: data?.[apiConstants.address] || "",
    [apiConstants.contact_person]: data?.[apiConstants.contact_person] || "",
    [apiConstants.contact_phone_number]: mobileNumber || "",
    [apiConstants.contact_email]: data?.[apiConstants.contact_email] || "",
    [apiConstants.shoot_rate]: data?.[apiConstants.shoot_rate] || "",
    [apiConstants.scouting_tags]: data?.[apiConstants.scouting_tags] || "",
    [apiConstants.date_scouted]: data?.[apiConstants.date_scouted] ? moment(data?.date_scouted, 'YYYY-MM-DD') : "",
    [apiConstants.dial_code]: country?.dial_code ? country : {
      "name": "United Kingdom",
      "flag": "🇬🇧",
      "code": "GB",
      "dial_code": "+44",
      "value": "+44",
      "label": "United Kingdom"
    },
  }
}

export const createCribSheetFormData = () => {
  return {
    [apiConstants.headline]: "",
    [apiConstants.description]: "",
  }
}

export const createLocFolderFormData = () => {
  return {

  }
}

export const verifyPwdData = () => {
  return {
    [apiConstants.password]: "",
  };
};
export const verifyPin = () => {
  return {
    [apiConstants.pin]: "",
  };
};

export const newBroadCastStepOneFormData = () => {
  return {
    [apiConstants.department]: [],
    [apiConstants.roles]: [],
    [apiConstants.user_ids]: [],
  };
};

export const newBroadCastStepTwoFormData = () => {
  return {
    [apiConstants.message]: "",
  };
};

export const newBroadCastStepOneSchema = () => {
  return yup
    .object()
    .shape({
      [apiConstants.department]: yup
        .array()
        .min(1, errorMessage.selectFieldRequired("Department")),
      // [apiConstants.roles]: yup.array().min(1, errorMessage.selectFieldRequired("Roles")),
      [apiConstants.user_ids]: yup
        .array()
        .min(1, errorMessage.selectFieldRequired("Crew members")),
    })
    .required();
};
export const createNewEvent = (data?: any) => {
  return {
    [apiConstants.eventName]: data?.[apiConstants.eventName] || "",
    [apiConstants.eventSubCategory]: data?.sub_category || "",
    [apiConstants.event_type]: data?.type || "",
    //[apiConstants.event_start_date]: data?.start_datetime?.splice(0,10) || '',
    [apiConstants.department]: [],
    // [apiConstants.department]: data?.department || '',
    [apiConstants.meeting_link]: data?.meeting_link || "",
    [apiConstants.eventStartTime]: "",
    [apiConstants.eventEndTime]: "",
    [apiConstants.description]: data?.description || "",
    // [apiConstants.event_location]: handleConvertCoordinates(data?.location.coordinates[0], data?.location.coordinates[1]) || ''
  };
};

export const addPrepDiary = (data?: any) => {
  return {
    [apiConstants.date]: data?.[apiConstants.date]
      ? moment(data?.[apiConstants.date])
      : "",
    [apiConstants.event_title]: data?.[apiConstants.event_title] || "",
  };
};

export const addPrepDiarySchema = () => {
  return yup
    .object()
    .shape({
      [apiConstants.date]: yup
        .string()
        .required(errorMessage.required_validation("Date")),
      [apiConstants.event_title]: yup
        .string()
        .required(errorMessage.required_validation("Event")),
    })
    .required();
};

export const updateCrewRole = () => {
  return {
    [apiConstants.overtime_hours]: "",
    [apiConstants.permission_type]: "",
    [apiConstants.department]: "",
  };
};

export const updateCrewRoleSchema = () => {
  return yup
    .object()
    .shape({
      [apiConstants.department]: yup
        .string()
        .required(errorMessage.required_validation("Department")),
      [apiConstants.overtime_hours]: yup
        .string()
        .required(errorMessage.required_validation("Contracted hours")),
      [apiConstants.permission_type]: yup
        .string()
        .required(errorMessage.required_validation("Permission type")),
    })
    .required();
};

export const crewGroupFormData = () => {
  return {
    [apiConstants.name]: "",
    [apiConstants.description]: "",
  };
};

export const crewGroupSchema = () => {
  return yup
    .object()
    .shape({
      [apiConstants.name]: yup
        .string()
        .required(errorMessage.required_validation("Group name")),
      [apiConstants.description]: yup
        .string()
        .required(errorMessage.required_validation("Group description")),
    })
    .required();
};

export const nightWorkingForm = () => {
  return {
    [apiConstants.start_time]: "",
    [apiConstants.end_time]: "",
  };
};

export const nightWorkingSchema = () => {
  return yup
    .object()
    .shape({
      [apiConstants.start_time]: yup
        .string()
        .required(errorMessage.required_validation("From time")),
      [apiConstants.end_time]: yup
        .string()
        .required(errorMessage.required_validation("To time")),
    })
    .required();
};

export const createScriptFormData = () => ({
  [apiConstants.show_type]: 'tv_show',
  [apiConstants.name]: '',
  [apiConstants.number_of_scenes]: '',
  [apiConstants.number_of_episodes]: '',
  [apiConstants.add_locations_to_vault]: true,
  [apiConstants.locations_date]: DateUtils.formatDateTime(DateUtils.getCurrentDate(), 'DD/MM/YYYY'),
  [apiConstants.create_photo_folders]: true,
});

export const sceneFormData = () => ({
  [apiConstants.set_name]: '',
  [apiConstants.scene_number]: '',
  [apiConstants.pages]: '',
  [apiConstants.day_or_night]: '',
  [apiConstants.scene_type]: 'location',
  [apiConstants.episode_number]: null,
});
